<template>
    <div class="community__item-container">
        <div class="community__item-outer">
            <div class="community__item"
                 :style='`background-color: ${community.color || "#11205f"};`'>
                <div class="community__item-inner--decoration"
                     :style="`background-image: url('${require('@/assets/img/oval-oval-oval-mask.svg')}')`">
                </div>
                <div class="community__item-inner">
                    <h2 class="item__caption" :style='`color: ${community.isBright ? "#2e384d" : "" }`'>
                      <CommunityKey :value="community.key"/>
                    </h2>
                </div>
            </div>
            <v-menu transition="slide-y-transition"
                    bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-ripple
                           small
                           absolute
                           dark
                           fab
                           bottom
                           right
                           v-on:click="openMenu(on, $event)"
                           transition="scroll-y-transition"
                           color="white">
                        <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                </template>
                <v-list class="list__menu">
                    <v-list-item class="list__menu-item">
                        <v-list-item-title class="list__menu-text">
                            <v-icon>mdi-dots-horizontal</v-icon>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!community.is_locked && can_edit" v-ripple @click="editCommunityDialog()" class="list__menu-item">
                        <v-list-item-title class="list__menu-text">
                            <v-img :src="require('@/assets/img/icons/pen.svg')"></v-img>
                            <span>Edit</span>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-ripple @click="openDuplicateCommunityDialog()" class="list__menu-item">
                        <v-list-item-title class="list__menu-text">
                            <v-img :src="require('@/assets/img/icons/duplicate.svg')"></v-img>
                            <span>Duplicate</span>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="can_unlock && community.is_locked" v-ripple @click="unlockCommunity()" class="list__menu-item">
                      <v-list-item-title class="list__menu-text">
                        <v-img :src="require('@/assets/img/icons/lock.svg')"></v-img>
                        <span>Unlock</span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="can_lock && !community.is_locked" v-ripple @click="lockCommunity()" class="list__menu-item">
                      <v-list-item-title class="list__menu-text">
                        <v-img :src="require('@/assets/img/icons/lock.svg')"></v-img>
                        <span>Lock</span>
                      </v-list-item-title>
                    </v-list-item>


                    <DeleteCommunity v-if="!community.is_locked && can_delete" :community="community.key.name" @delete="deleteCommunity">
                    </DeleteCommunity>
                </v-list>
            </v-menu>
        </div>
        <div class="community-item__info">
            <div class="community-item__info-item">
                <div class="info-row">
                </div>
                <div class="info-row">
                    <v-img :src="require('@/assets/img/icons/folder-icon.svg')"></v-img>
                    {{nProjectsUsing}}
                </div>
                <div class="info-row">
                    <v-img :src="require('@/assets/img/icons/clock.svg')"></v-img>
                    {{created_timestamp}}
                </div>
            </div>
        </div>
        <v-dialog v-model="editDialog" width="900">
            <EditCommunity :key="editKey" v-model="query" @confirm="editCommunity"></EditCommunity>
        </v-dialog>

        <v-dialog v-model="saveDialog" width="900">
          <SaveCommunity
            :key="saveKey"
            :initial_namespace="community.key.namespace"
            :initial_name="saveCommunityInitialName"
            @confirm="saveCommunity($event)"
          >
          </SaveCommunity>
      </v-dialog>

      <v-dialog v-model="deleteDialog" width="900">
        <v-card>
          <v-card-text class="pa-4">
            <div v-if="deleteError">
              <h2>Cannot delete community</h2>
              <template v-if="deleteError.content.communities.length > 0">
                  It is used in following communities:
                <ul>
                <li v-for="c,i in deleteError.content.communities">
                  <strong>{{c.namespace}}."{{c.name}}""</strong>
                </li>
              </ul>
              </template>
              <template v-if="deleteError.content.projects.length > 0">
                  it is used in following projects:
                <ul>
                  <li v-for="(p,i) in deleteError.content.projects"
                      :key="i">
                      <a :href="url_to_project(p)">Project {{ p }}</a>
                  </li>
                </ul>
              </template>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
    import moment from "moment";
    import {store} from "../../store/store";
    import EditCommunity from "./EditCommunity";
    import DeleteCommunity from "../DeleteCommunity";
    import SaveCommunity from "./SaveCommunity";
    import CommunityKey from "./CommunityKey";
    import {uuid} from  "../../_utils/uuid";
    import {communityCan} from '../../services/community.service';

    export default {
        name: "CommunityItem",
        props: ['community', 'errMessage', 'index', 'dateRange'],
        components:  { EditCommunity, DeleteCommunity, SaveCommunity, CommunityKey },
        data: () => ({
            editDialog: false,
            deleteDialog: false,
            deleteError: null,
            saveDialog: false,
            query: "",
            editKey: 0,
            saveKey: 0,
            saveCommunityInitialName: "",
            can_edit: false,
            can_delete: false,
            can_lock: false,
            can_unlock: false,
        }),
        computed: {
            created_timestamp() {
                return moment(this.community.created_at).fromNow()
            },
            usersShare() {
                return this.community.usersShare
            },
            startDate() {
                // TODO fix date formatting
                return this.community.startDate ? this.community.startDate.slice(0, 10) : null
            },
            endDate() {
                // TODO fix date formatting
                return this.community.endDate ? this.community.endDate.slice(0, 10) : null
            },

            usersCount() {
                return this.community.usersCount
            },
            nProjectsUsing() {
                return this.community.nProjectsUsing
            },
            type() {
                return this.community.type
            }
        },
        methods: {
            openMenu(on, e) {
              this.can_edit = false;
              this.can_delete = false;
              this.can_lock = false;
              this.can_unlock = false;

              if (communityCan('update_community', this.community.key.namespace, this.community.key.name)){
                this.can_edit = true;
              }

              if (communityCan('delete_community', this.community.key.namespace, this.community.key.name)){
                this.can_delete = true;
              }

              if (communityCan('lock_community', this.community.key.namespace, this.community.key.name)){
                this.can_lock = true;
              }
              if (communityCan('unlock_community', this.community.key.namespace, this.community.key.name)){
                this.can_unlock = true;
              }
              on.click(e);
            },
            copyCommunity: function () {
                store.dispatch('getCommunityQuery', this.community.key).then(resp => {
                    this.$router.push({
                        name: 'CopyCommunity',
                        params: {dialog: 'true', communityName: this.community.key, formState: resp, beingCopied: true}
                    });
                })
            },
            editCommunityDialog: function () {
                store.dispatch('getCommunityQuery', this.community.key)
                    .then(q => {
                        this.query = q
                        this.editDialog = true
                    })
            },
            editCommunity(query) {
                console.log(query)
                store.dispatch("editCommunity",
                    {name: this.community.key, query: query})
                this.editDialog = false
            },
            deleteCommunity() {
                store.dispatch("deleteCommunity", this.community.key)
                  .then(_ => {
                    this.deleteDialog = false
                  })
                  .catch(err => {
                    console.log(err.response)
                    this.deleteError = err.response.data
                    this.deleteDialog = true
                  })
            },
            openDuplicateCommunityDialog() {
                store.dispatch('getCommunityQuery', this.community.key)
                    .then(q => {
                        this.query = q;
                        this.saveDialog = true;
                        this.saveCommunityInitialName = this.community.key.name + " duplicate";
                    })

            },
            closeDuplicateCommunityDialog() {
                this.saveDialog = false;
            },
            // duplicate a community
            saveCommunity: function (community_to_save) {
                console.log("CommunityItem > saveCommunity", community_to_save);
                // store community
                let community = {
                  name: {
                    namespace: community_to_save.namespace,
                    name: community_to_save.name,
                  },
                  query: this.query
                }
                store.dispatch('addCommunity', community)
                    .then(resp => {
                        this.closeDuplicateCommunityDialog();
                    })
                    .catch(err => {
                        /*if (err.response) {
                            this.alert_in_dialog_text = "Creation failed: " + err.response.status + " " + JSON.stringify(err.response.data)
                        } else {
                            this.alert_in_dialog_text = "Creation failed: " + JSON.stringify(err)
                        }*/
                        console.log("Cought error in CommunityItem > saveCommunity > addCommunity");
                    });
            },
            lockCommunity() {
                store.dispatch('lockCommunity', this.community.key);
            },
            unlockCommunity() {
                store.dispatch('unlockCommunity', this.community.key);
            },
            url_to_project(pid){
                return "#/projects/project/" + pid;
            },
        },
        watch: {
            editDialog(val, oldVal) {
                if (val) {
                    this.editKey = uuid()
                }
            },
            saveDialog (val, oldVal) {
              if (val) {
                this.saveKey = uuid();
              }
            }
        },
        mounted() {
            if (!this.community.type) {
                store.dispatch('communityKPIs', {key: this.community.key, dateRange: this.dateRange})
            }
        }
    }
</script>

<style scoped>

</style>
